import { render, staticRenderFns } from "./Clinicas.vue?vue&type=template&id=63c89243&scoped=true&"
import script from "./Clinicas.vue?vue&type=script&lang=js&"
export * from "./Clinicas.vue?vue&type=script&lang=js&"
import style0 from "./Clinicas.vue?vue&type=style&index=0&id=63c89243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c89243",
  null
  
)

export default component.exports